import FilterTable from "./filterTable";

export default function resetFilter(instance) {
    //get filter
    let filter = instance.coverageToolResultsFilter;

    filter.value = "";
    FilterTable(instance);
}
